import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const TipificacionService = {
    fetchTipificaciones: async (token) => {
        try {
            const response = await axios.get(buildApiUrl('/api/ajustes/tipificaciones'), {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data.tipificaciones || [];
        } catch (error) {
            console.error('Error en TipificacionService.fetchTipificaciones:', error);
            throw error;
        }
    },
    guardarTipificacion: async ({ token, formData, editingItem }) => {
        try {
            if (editingItem) {
                await axios.put(
                    buildApiUrl(`/api/ajustes/tipificaciones/${editingItem.id}`),
                    formData,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
            } else {
                await axios.post(buildApiUrl('/api/ajustes/tipificaciones'), formData, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
        } catch (error) {
            console.error('Error en TipificacionService.guardarTipificacion:', error);
            throw error;
        }
    },
};
